module.exports = __webpack_public_path__ + "static/media/ev.644456ea.png";